import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const UnorderedList = ({ fields, rendering }) => {
  return (
    <ul className="vds-generic-list vds-generic-list" data-testid={fields.testid?.value}>
      <Placeholder name="unorderedList-items" rendering={rendering} />
    </ul>
  );
};

export default UnorderedList;
